/* eslint-disable prefer-template */
import Config from 'es6/core/config';
import ItemQuizBase from 'es6/controllers/apps/quizzes/item-quiz-base';
import Logger from 'es6/services/logger';
import { ResultTypes } from 'es6/models/quiz-result';
import SelfAssessmentScreen from 'es6/components/apps/screens/self-assessment';
import SelfAssessmentStudyScreen from 'es6/components/apps/screens/self-assessment-study';

/**
 * @this SelfAssessmentQuizBase
 */
function handleReveal() {
  if (this.paused) {
    return;
  }

  this.result.beginPhase('quiz');
  this._screenManager.renderComponent(SelfAssessmentStudyScreen, {
    itemPackage:          this.itemPackage,
    isNew:                !this.itemPackage.memory,
    playAudioOnMount:     !this._playAudioOnRecall,
    onVeryWell:           this.returnedFromQuiz.bind(this, ResultTypes.EASY),
    onWell:               this.returnedFromQuiz.bind(this, ResultTypes.OK),
    onNotWell:            this.returnedFromQuiz.bind(this, ResultTypes.HARD),
    onDontKnow:           this.returnedFromQuiz.bind(this, ResultTypes.INCORRECT),
    isRepeatQuiz:         this._isRepeat,
    showTranscription:    Config.showTranscriptions,
  });
}

/**
 * @this SelfAssessmentQuizBase
 */
function handleSkip() {
  if (this.paused) {
    return;
  }

  this._screenManager.fireEvent('skip_item_initiated');
}

/**
 * @this SelfAssessmentQuizBase
 */
function renderComponent() {
  const cueSound = this._playAudioOnRecall && this.itemPackage.sound ?
    this.itemPackage.sound :
    null;

  const props = {
    cue:         this._recallCue,
    cueSound,
    isNew:       !this.itemPackage.memory,
    isRepeat:    this._isRepeat,
    onReveal:    handleReveal.bind(this),
    onSkip:      handleSkip.bind(this),
    prompt:      this._prompt,
    response:    this._recallResponse,
  };

  this._screenManager.renderComponent(SelfAssessmentScreen, props);
}

class SelfAssessmentQuizBase extends ItemQuizBase {
  constructor(...args) {
    super(...args);
    this._playAudioOnRecall = false;
    this._isRepeat = false;
  }

  show() {
    Logger.info('Quiz', 'Showing ' + this.quizType + ' quiz for ' + this.itemPackage.item.cue.text, this);
    this.result.beginPhase('recall');
    renderComponent.call(this);
  }

  /*
   *  @Override
   */
  returnedFromQuiz(resultType) {
    this.result.setResult(resultType);
    this.finishQuiz();
  }
}

export default SelfAssessmentQuizBase;
